import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { MatSelectChange } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr'

interface Band {
  band: string;
}
interface Function {
  functions: string;
}
@Component({
  selector: 'app-competency-add-new',
  templateUrl: './competency-add-new.component.html',
  styleUrls: ['./competency-add-new.component.scss'],
})
export class CompetencyAddNewComponent implements OnInit {
  competencyForm: FormGroup;
  uniqueFunctions: Function[] = [];
  uniqueBands: Band[] = [];
  buttonColorName: any = 'gray';
  buttonColorCode: any = 'gray'
  isButtonDisabled: boolean = true;
  loggedInUserCompanyID: any;
  maxTotalWeight = 100;
  selectedHrAdminFunction: any;
  selectedBand: any;
  selectedTab: any;
  competencyList: any[] = [];
  hasDuplicateCompetency: boolean = false;


  competencyFormGroup: FormGroup = new FormGroup({});
  editId: any;
  operation: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserId: any;
  selectedYearForCompetency: any;
  dropdownData: any = [];
  dropdownSettings: IDropdownSettings = {};
  loggedInUserEmpCode: any;
  selectedFunctions: string[] = [];
  sendSelectedFunction: any;
  selectedCompetency: any;
  selectedValueOfDepartment: string = '';
  getListOfDepartmentsOfComp: any = [];
  bandListHrAdmin: any = [];

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
    private httpService: HttpService,
    private config: Config,
    public dialogRef: MatDialogRef<CompetencyAddNewComponent>,
    private fb: FormBuilder,
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private datePipe: DatePipe,
    private loader: LoaderService,
    public dialog: MatDialog,
    private upperCasePipe: UpperCasePipe,
    private toastr: ToastrService
  ) {
    this.competencyForm = this.fb.group({
      selectedHrAdminFunction: [null, Validators.required],
      selectedBand: [null, Validators.required],
      competencies: this.fb.array([this.createCompetency()],
        { validators: this.uniqueCompetencyValidator() })
    });

  }


  get hasDuplicateCompetencyNames(): boolean {
    const names = this.competencyArray.controls.map(c => c.get('competencyName')?.value);
    return new Set(names).size !== names.length;
  }

  get hasDuplicateCompetencyDefinitions(): boolean {
    const definitions = this.competencyArray.controls.map(c => c.get('competencyDefinition')?.value);
    return new Set(definitions).size !== definitions.length;
  }


  deleteCompetency(index: number) {
    this.competencyArray.removeAt(index);
    this.updateAddButtonState();
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    // this.getBandFunctionList();

    this.addCompetency();
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    // this.getCompetencyById()
    this.operation = this.dialogData.operation;
    this.editId = this.dialogData.editId;
    this.selectedYearForCompetency = this.dialogData.selectedYear
    this.initializeForm();
    this.getCompetencySetup();
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getAllFunctionsByYearRangeReport();

  }

  initializeForm() {
    this.competencyForm = this.fb.group({
      selectedHrAdminFunction: [null, Validators.required],
      selectedBand: [null, Validators.required],
      competencies: this.fb.array([this.createCompetency()], this.uniqueCompetencyValidator())
    });
  }

  getCompetencySetup() {
    this.httpService.callGetService(this.config.getCompetencySetupById + this.loggedInUserCompanyID + '/' + this.selectedYearForCompetency)
      .subscribe((response: any) => {
        const competencySetup = response?.data;
        if (competencySetup) {
          const selectedCompetency = competencySetup.selectcompetency;
          this.selectedCompetency = selectedCompetency;
          this.getActiveDeptFunctionForSetup();
        }
      });
  }

  createCompetency(): FormGroup {
    return this.fb.group({
      competencyName: ['', Validators.required],
      competencyDefinition: ['', Validators.required],
      weight: ['', [Validators.required, Validators.min(0)]]
    });
  }


  uniqueCompetencyValidator(): ValidatorFn {
    return (formArray: AbstractControl): { [key: string]: boolean } | null => {
      const competencies = formArray.value;
      const namesAndDefinitions = new Set<string>();

      for (const competency of competencies) {
        const name = competency.competencyName?.trim();
        const definition = competency.competencyDefinition?.trim();

        if (name && definition) {
          const key = `${name}-${definition}`;

          if (namesAndDefinitions.has(key)) {
            return { 'duplicateCombination': true };
          }

          namesAndDefinitions.add(key);
        }
      }
      return null;
    };
  }



  addCompetency(): void {
    const competencyFormGroup = this.fb.group({
      competencyName: ['', Validators.required],
      competencyDefinition: ['', Validators.required],
      weight: ['', Validators.required],
    });
    this.competencyArray.push(this.createCompetency());

  }
  validateWeight(event: any): void {
    const input = event.target.value;
    if (input < 0) {
      event.target.value = input.replace('-', '');
    }
  }




  duplicateCompetencyValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control instanceof FormArray) {
      const competencies = control.controls as FormGroup[];
      const seen = new Set<string>();
      for (const competency of competencies) {
        const name = competency.get('competencyName')?.value;
        const definition = competency.get('competencyDefinition')?.value;
        const pair = `${name}-${definition}`;

        if (seen.has(pair)) {
          return { duplicateCompetency: true };
        }
        seen.add(pair);
      }
    }
    return null;
  }



  get competencyArray(): FormArray {
    return this.competencyForm.get('competencies') as FormArray;
  }

  onFunctionChange(event: any) {
    this.selectedValueOfDepartment = event; // Update the property with the selected value
    this.competencyForm.controls['selectedBand'].setValue(null);
    this.getBandListHrAdmin();
  }


  onBandSelectionChange(event: any) {
    this.selectedBand = event.value;
  }


  onAddButtonClick() {
    if (this.competencyForm.valid) {
      const formValue = this.competencyForm.value;
      const request = {
        band: this.selectedBand,
        companyId: this.loggedInUserCompanyID,
        competencyMasterlist: formValue.competencies.map((competency: any) => ({
          competencyDefination: competency.competencyDefinition,
          competencyName: competency.competencyName,
          weightageNo: competency.weight
        })),
        functionName: this.selectedHrAdminFunction,
        yearRange: this.selectedYearForCompetency,
      };

      // Log request payload for debugging

      this.loader.simpleLoaderWithDuration();
      this.httpService.callPostService(this.config.addCompetencyMaster, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }).afterClosed().subscribe(() => {
              this.closeDialog();
            });
          } else {
          }
        }, (error) => {
          this.loader.dismissLoader();
        });
    }
  }





  getAllCompetencyList(specificId?: number) {
    this.httpService.callGetService(this.config.getAllCompetencyList + this.loggedInUserCompanyID + "/All")
      .subscribe((response: any) => {
        if (Array.isArray(response.data)) {
          let filteredData = response.data;
          if (specificId !== undefined) {
            filteredData = response.data.filter((item: any) => item.id === specificId);
          }
          this.competencyList = filteredData.map((item: any) => ({
            ...item,
            formattedPublishedOn: this.datePipe.transform(item.publishedOn, 'dd-MM-yyyy'),
            formattedCreatedAt: this.datePipe.transform(item.createdAt, 'dd-MM-yyyy'),
            formattedLastModifiedOn: this.datePipe.transform(item.lastModifiedOn, 'dd-MM-yyyy')
          }));
        } else {
        }
      }, (error) => {
      });
  }

  populateForm(competency: any) {
    this.competencyArray.push(this.fb.group({
      competencyName: [competency.competencyName],
      competencyDefinition: [competency.competencyDefinition],
      weight: [competency.weight]
    }));
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getTotalWeight(): number {
    let totalWeight = 0;
    this.competencyArray.controls.forEach(control => {
      totalWeight += control.get('weight')?.value || 0;
    });
    return totalWeight;
  }

  updateAddButtonState() {
    const totalWeight = this.getTotalWeight();
    if (totalWeight != 100 || this.competencyForm.get('competencies')?.hasError('duplicateCombination')
      || this.competencyForm.value.selectedHrAdminFunction == null || this.competencyForm.value.selectedBand == null) {
      this.buttonColorCode = 'gray';
      this.isButtonDisabled = true;
    } else {
      this.buttonColorCode = this.buttonColorName;
      this.isButtonDisabled = false;
    }
  }

  ngDoCheck() {
    this.updateAddButtonState();
  }


  onWeightChange() {
    this.competencyArray.controls.forEach((control) => {
      const group = control as FormGroup;
      const weightControl = group.get('weight');
      if (weightControl) {
        let weightValue = weightControl.value;
        if (weightValue < 0) {
          weightValue = '';
          weightControl.setValue(weightValue);
        }
        const totalWeight = this.getTotalWeight();
        if (totalWeight > this.maxTotalWeight) {
          weightControl.setErrors({ maxWeightExceeded: true });
        } else {
          weightControl.setErrors(null);
        }
      }
    });

    this.updateAddButtonState();
  }




  getCompetencyById() {
    this.httpService.callGetService(this.config.getcompetencyById + this.loggedInUserCompanyID + "/" + this.editId)
      .subscribe((response: any) => {

        const data = response.data;
        data.competencyMasterlist.forEach((item: any) => {
        });
      });
  }



  getAllFunctionsByYearRangeReport() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
    };

    this.httpService.callPostService(this.config.getAllFunctionsByYearRange, request).subscribe(
      (response: any) => {
        if (response && response.status) {
          this.dropdownData = response.data;
        } else {
        }
      },
      (error) => {
      }
    );
  }

  onItemSelect(SelectedFunction: MatSelectChange): void {
    this.sendSelectedFunction(this.selectedFunctions);
  }

  onItemDeselect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeselectAll(items: any) {

  }

  // getFunctionListBand() {
  //   const request = {
  //     companyId: this.loggedInUserCompanyID,
  //     managerCode: null,
  //     yearRange: this.selectedYearForCompetency,      
  //   };


  //   this.httpService.callPostService(this.config.getAllBandsByHrAdmin, request)
  //     .subscribe((data: any) => {
  //       if (data?.status) {
  //         // Directly assign the response data if it is an array of bands
  //         this.uniqueBands = data.data || [];
  //       } else {
  //       }
  //     }, (error: any) => {
  //     });
  // }


  //latest function and band api dependent


  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  getBandListHrAdmin() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
      function: [this.selectedValueOfDepartment],
      gradeOrBand: this.selectedCompetency
    };

    this.httpService.callPostService(this.config.GetHrAdminBandByYear, request)
      .subscribe(
        (response: any) => {
          this.bandListHrAdmin = [];
          if (response?.status) {
            response?.data?.forEach((ele: any) => {
              let obj = {
                id: ele,
                name: ele,
              }
              this.bandListHrAdmin.push(obj);
            });
          } else {
          }
        },
        (error: any) => {
        }
      );
  }


  onSubmit(): void {
    if (this.competencyForm.valid) {
      this.closeDialog();
      this.loader.simpleLoaderWithDuration();
      const formValue = this.competencyForm.value;
      const request = {
        band: formValue.selectedBand,
        companyId: this.loggedInUserCompanyID,
        competencyMasterlist: formValue.competencies.map((competency: any) => ({
          competencyDefination: competency.competencyDefinition,
          competencyName: competency.competencyName,
          weightageNo: competency.weight
        })),
        functionName: formValue.selectedHrAdminFunction,
        yearRange: this.selectedYearForCompetency,
      };

      this.httpService.callPostService(this.config.addCompetencyMaster, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }).afterClosed().subscribe(() => {
              this.closeDialog();
            });
          } else {
          }
        }, (error) => {
          this.loader.dismissLoader();
        });
    }
  }
  getBandsByDepartment() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": [
        this.selectedValueOfDepartment
      ]
    }
    this.httpService.callPostService(this.config.getBandsByDepartment, request).subscribe((result: any) => {
      this.bandListHrAdmin = [];
      result?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.bandListHrAdmin.push(obj);
      });
      this.bandListHrAdmin = this.bandListHrAdmin.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getGradesByDepartment() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": [
        this.selectedValueOfDepartment
      ]
    }
    this.httpService.callPostService(this.config.getGradesByDepartment, request).subscribe((result: any) => {
      this.bandListHrAdmin = [];
      result?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.bandListHrAdmin.push(obj);
      });
      this.bandListHrAdmin = this.bandListHrAdmin.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  checkLengthOfField(event:any) {
    var string = event.target.value
    if (string?.length > 254) {
      this.toastr.error('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    } else {
    }
  }
  getActiveDeptFunctionForSetup() {
    const request = {
      "band": [],
      "companyId": this.loggedInUserCompanyID,
      "function": [],
      "gradeOrBand": this.selectedCompetency,
      "managerCode": null,
      "yearRange": this.selectedYearForCompetency
    }
    this.httpService.callPostService(this.config.getFunctionsByYearRange,request).subscribe((data: any) => {
      
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
}
